import React                  from 'react';
import { WithRenderName }     from '@widesk-ui/mixins/ApiModelRenderName';
import { WithLocalizedLabel } from '@widesk-core/mixins/ApiModelLocalizedLabel';
import ApiModel               from '@widesk-core/models/ApiModel';
import View                   from '@widesk-ui/components/View';

export type ConfirmOptions = {
	actionLabel?: string,
	hideModelName?: boolean,
	content?: React.ReactNode;
	modelLabel?: string;
	modelName?: string;
};

type M = ApiModel & WithRenderName & WithLocalizedLabel;

const confirmModelMessage = (modelArr: M | M[], options: ConfirmOptions) => {
	const models = Array.isArray(modelArr) ? modelArr : [modelArr];

	const actionLabel = options.actionLabel || 'supprimer';

	const isMany = models.length > 1;

	const renderModelLabel = (model: M) => {
		return (
			<View row gap="xs">
				{options.hideModelName ? '' : `${options.modelName || model.localize()} - `}
				{options.modelLabel || model.renderName()}
			</View>
		);
	};

	return (
		<span>
			{`Voulez-vous ${actionLabel} ${isMany ? `les éléments` : `l'élément`} : `}

			<ul>
				{models.map(m => {
					return (
						<li key={m.id}>
							{renderModelLabel(m)}
						</li>
					);
				})}
			</ul>
		</span>
	);
};

export const confirmModelAction = (m: M | M[], options: ConfirmOptions) => {
	const actionLabel = options.actionLabel || 'supprimer';
	const models = Array.isArray(m) ? m : [m];

	return {
		title: confirmModelMessage(models, { actionLabel }),
		content: options.content,
	};
};

export default confirmModelMessage;
